module.exports = __webpack_public_path__ + "img/组 1117@2x.debd9731.png";